// @ts-nocheck
import React from 'react';
import WorkflowPage from './WorkflowPageFactory';
import { ParachutePayments as ParachutePaymentsForm } from '../workflow/CompanyApp';

export default function ParachutePaymentsPage() {
  return (
    <WorkflowPage stepId="parachute">
      {({
        data,
        setData,
        navigateTo,
        parachuteSubTab,
        setParachuteSubTab,
        parachuteEquitySubTab,
        setParachuteEquitySubTab,
      }) => (
        <ParachutePaymentsForm
          formData={data}
          setFormData={setData}
          setActiveTab={navigateTo}
          subTab={parachuteSubTab}
          setSubTab={setParachuteSubTab}
          equitySubTab={parachuteEquitySubTab}
          setEquitySubTab={setParachuteEquitySubTab}
        />
      )}
    </WorkflowPage>
  );
}
